let tempIdCounter = 0;

function generateTempId(prefix = "msg") {
  tempIdCounter += 1;
  return `${prefix}-${Date.now()}-${tempIdCounter}`;
}

function normalizePart(part) {
  if (!part || typeof part !== "object") {
    return part;
  }

  if (part.type === "reasoning" && part.reasoning && !part.text) {
    const { reasoning, ...rest } = part;
    return {
      ...rest,
      type: "reasoning",
      text: part.text ?? reasoning,
    };
  }

  if (part.type === "file") {
    const mediaType = part.mediaType ?? part.mimeType;

    return {
      ...part,
      mediaType,
    };
  }

  return part;
}

export function getMessageText(message) {
  if (!message) {
    return "";
  }

  if (typeof message === "string") {
    return message;
  }

  const parts = Array.isArray(message.parts) ? message.parts : [];
  const textFromParts = parts
    .map((part) => {
      if (!part || typeof part !== "object") {
        return "";
      }

      if (part.type === "reasoning") {
        return "";
      }

      if (typeof part.text === "string") {
        return part.text;
      }

      if (typeof part.value === "string") {
        return part.value;
      }

      if (typeof part.output === "string") {
        return part.output;
      }

      if (typeof part.delta === "string") {
        return part.delta;
      }

      return "";
    })
    .filter(Boolean)
    .join(" ");

  if (textFromParts) {
    return textFromParts;
  }

  // If parts contained reasoning, don't fall back to message.content which may include reasoning text
  const hasReasoningPart = parts.some(
    (part) => part && typeof part === "object" && part.type === "reasoning"
  );
  if (hasReasoningPart) {
    return "";
  }

  if (typeof message.content === "string") {
    return message.content;
  }

  if (Array.isArray(message.content)) {
    return message.content
      .map((part) => part?.text || "")
      .filter(Boolean)
      .join(" ");
  }

  if (typeof message.text === "string") {
    return message.text;
  }

  return "";
}

export function toUiMessage(message) {
  if (!message || typeof message !== "object") {
    return message;
  }

  if (Array.isArray(message.parts)) {
    const parts = message.parts.map(normalizePart);
    const content = getMessageText({ ...message, parts });

    return {
      id: message.id ?? generateTempId("msg"),
      ...message,
      parts,
      content,
    };
  }

  const content = getMessageText(message);
  const parts = content
    ? [
        {
          type: "text",
          text: content,
        },
      ]
    : [];

  return {
    id: message.id ?? generateTempId("msg"),
    role: message.role ?? "user",
    parts,
    content,
    ...message,
  };
}

export function toLegacyMessage(message) {
  if (!message || typeof message !== "object") {
    return message;
  }

  const uiMessage = toUiMessage(message);
  const content = getMessageText(uiMessage);

  return {
    ...uiMessage,
    content,
  };
}

export function ensureUiMessages(messages) {
  if (!Array.isArray(messages)) {
    return [];
  }

  return messages.map((msg) => toUiMessage(msg));
}
